import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-key',
  templateUrl: './wallet-key.component.html',
  styleUrls: ['./wallet-key.component.scss']
})
export class WalletKeyComponent {

}
